/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Integration_Flow_Title4Inputs */

const en_svc_ai_integration_flow_title4 = /** @type {(inputs: Svc_Ai_Integration_Flow_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Product workflow AI`)
};

const ar_svc_ai_integration_flow_title4 = /** @type {(inputs: Svc_Ai_Integration_Flow_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ذكاء تدفقات المنتج`)
};

const bn_svc_ai_integration_flow_title4 = /** @type {(inputs: Svc_Ai_Integration_Flow_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রোডাক্ট ওয়ার্কফ্লো AI`)
};

const de_svc_ai_integration_flow_title4 = /** @type {(inputs: Svc_Ai_Integration_Flow_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produkt-Workflow-KI`)
};

const es_svc_ai_integration_flow_title4 = /** @type {(inputs: Svc_Ai_Integration_Flow_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IA del flujo de trabajo del producto`)
};

const fr_svc_ai_integration_flow_title4 = /** @type {(inputs: Svc_Ai_Integration_Flow_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IA du flux de travail du produit`)
};

const pt_svc_ai_integration_flow_title4 = /** @type {(inputs: Svc_Ai_Integration_Flow_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`IA do fluxo de trabalho do produto`)
};

const zh_svc_ai_integration_flow_title4 = /** @type {(inputs: Svc_Ai_Integration_Flow_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`产品工作流程人工智能`)
};

const tr_svc_ai_integration_flow_title4 = /** @type {(inputs: Svc_Ai_Integration_Flow_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ürün iş akışı yapay zekası`)
};

const ru_svc_ai_integration_flow_title4 = /** @type {(inputs: Svc_Ai_Integration_Flow_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рабочий процесс продукта ИИ`)
};

const pl_svc_ai_integration_flow_title4 = /** @type {(inputs: Svc_Ai_Integration_Flow_Title4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI przepływu pracy w produkcie`)
};

/**
* | output |
* | --- |
* | "Product workflow AI" |
*
* @param {Svc_Ai_Integration_Flow_Title4Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_integration_flow_title4 = /** @type {((inputs?: Svc_Ai_Integration_Flow_Title4Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Integration_Flow_Title4Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_integration_flow_title4(inputs)
	if (locale === "bn") return bn_svc_ai_integration_flow_title4(inputs)
	if (locale === "de") return de_svc_ai_integration_flow_title4(inputs)
	if (locale === "es") return es_svc_ai_integration_flow_title4(inputs)
	if (locale === "fr") return fr_svc_ai_integration_flow_title4(inputs)
	if (locale === "pt") return pt_svc_ai_integration_flow_title4(inputs)
	if (locale === "zh") return zh_svc_ai_integration_flow_title4(inputs)
	if (locale === "tr") return tr_svc_ai_integration_flow_title4(inputs)
	if (locale === "ru") return ru_svc_ai_integration_flow_title4(inputs)
	if (locale === "pl") return pl_svc_ai_integration_flow_title4(inputs)
	return en_svc_ai_integration_flow_title4(inputs)
});
export { svc_ai_integration_flow_title4 as "svc_ai-integration_FLOW_title" }